import React from 'react';

class PrivateContent extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      accessGranted: false,
    };
    this.handleAuthResponse = this.handleAuthResponse.bind(this);
  }

  componentDidMount() {
    if (!this.props.bypassed) {
      this.props
        .onAuth()
        .then(this.handleAuthResponse)
        .catch(this.handleAuthResponse);
    }
  }

  handleAuthResponse(statusCode) {
    switch (statusCode) {
      case 204: {
        this.setState({ accessGranted: true });
        break;
      }
      case 403: {
        this.props.onForbidden();
        break;
      }
      case 401:
      default: {
        this.props.onAuthFailure();
        break;
      }
    }
  }

  render() {
    return this.props.bypassed
      ? this.props.children
      : this.state.accessGranted
      ? this.props.children
      : null;
  }
}

export default PrivateContent;
